import "./style.css";
import { NavDropdown, Dropdown, Spinner, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import apiEndPoint from "../../utils/apiEndPoint";
import { Fragment, useEffect } from "react";
import Templateview from "../templateview";
import { Select } from "antd";
import React, { useState } from 'react';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { loadFromLocalStorage, saveToLocalStorage } from "../../utils/LocalStorageUtils";
import { apiCall, failedMessage, successMessage } from "../../utils/httpClient";
import Footer from "../../layout/footer";
import Header from "../../layout/header";

export default function Orders() {
  const [orderList, setOrderList] = useState([]);
  const [siteUrl, setSiteUrl] = useState('');
  const [base_url, setbaseurl] = useState('');
  const [isLoading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [selectPage, setSelectPage] = useState("");
  const [templateViewPage, setTemplateViewPage] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const authData = loadFromLocalStorage("AUTH_DATA");

  useEffect(() => {
    getOrderList();
  }, [currentPage]);

  const getOrderList = async () => {
    let params = { limit: 6, offset: currentPage === 0 ? 0 : currentPage - 1 }
    const { data } = await apiCall("post", apiEndPoint.GETORDERLIST, params);
    if (data.status === 200) {
      setOrderList(data.data);
      setSiteUrl(data.site_url);
      setbaseurl(data.base_url);
      setTotalPages(Math.ceil(data?.total_data / 6));
    } else {
      setOrderList([]);
      failedMessage(data.message);
    }
    setLoading(false)
  };
  const handleSavedTemplate = async (item) => {
    const { data } = await apiCall("post", apiEndPoint.FAVOURITETHEMESTATUSUPDATE, {
      is_favourite: true,
      template_id: item._id,
    });
    if (data.status === 200) {
      successMessage(data.message)
      getOrderList();
    }
  };
  const handleConnectDomain = item => {
    let newItem = { ...item };
    // setModalVisible(true);
    // newItem.theme_url = siteUrl + newItem.path_name;
    // setModalData(newItem);
    // navigation.navigate("DomainConnect")
  };
  const navigate = useNavigate();
  return (
    <Fragment>
      {selectPage === "" ? (
        <>
          {/* <Header /> */}
          <div className="order-title">
            <h3>Manage your website</h3>
          </div>

          <section className="order-card-sec">
            <div className="container-fluid">

              {isLoading ? <center style={{ paddingTop: '15%' }}>
                <Spinner animation="border" role="status" />
              </center> :
                (<div className="order-container">
                  <div className="row">
                    {orderList.length > 0 ?
                      <Fragment>
                        {orderList.map((item, index) => (
                          <div className="col-lg-12" key={index}>
                            <div className="mb-3">
                              <div className="card">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <img
                                      className="w-100 thumbnail"
                                      style={{backgroundImage: `url(${base_url + item.thumbnail})`,
                                      }}
                                    />
                                  </div>
                                  <div className="col-lg-6 pt-3 p-4">
                                    <span>
                                      <h6 style={{ color: '#000000' }}>{siteUrl + item.path_name}</h6>
                                      {Number(item.order_type) === 1 ? (
                                        <small style={{ color: '#000000' }}>Not Publish</small>
                                      ) : (
                                        <Button style={{ color: '#ffffff' }} onClick={() => { handleConnectDomain(item); navigate("/domain"); }}>
                                          Connect Domain
                                        </Button>
                                      )}

                                    </span>
                                    <div className="crds-btn mt-4">
                                      <Button
                                        variant="outline-primary"
                                        onClick={() => {
                                          let newItem = { ...item };
                                          newItem.theme_url = newItem.path_name;
                                          newItem.order_id = newItem._id;
                                          newItem._id = newItem.template_id;
                                          saveToLocalStorage('selectTemplate', newItem);
                                          saveToLocalStorage("selectOrderDetail", null);
                                          navigate("/templateform");
                                        }}
                                      >
                                        Edit
                                      </Button>{" "}
                                      <Button
                                        variant="outline-primary"
                                        onClick={() => {
                                          let newItem = { ...item };
                                          newItem.theme_url = newItem.path_name;
                                          newItem.order_id = newItem._id;
                                          newItem._id = newItem.template_id;
                                          saveToLocalStorage('selectTemplate', newItem);
                                          saveToLocalStorage("selectOrderDetail", null);
                                          setSelectPage("TemplateView");
                                          setTemplateViewPage(newItem);
                                        }}
                                      >
                                        Preview Site
                                      </Button>
                                      {""}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div className="mt-4">
                          <ResponsivePagination
                            current={currentPage}
                            total={totalPages}
                            onPageChange={setCurrentPage}
                          />
                        </div>
                      </Fragment>
                      : <center><h6>Websites not available</h6></center>}
                  </div>
                </div>)}
            </div>
          </section>
          {/* <Footer /> */}
        </>

      ) : (
        <Templateview
          templateViewPage={templateViewPage}
          selectPage={selectPage}
          setSelectPage={setSelectPage}
          base_url={siteUrl}
        />

      )}
    </Fragment>
  );
}

